<template>
	<span>
		<el-tag size="mini" v-if="state == 1" type="warning">{{ getName(1) }}</el-tag>
		<el-tag size="mini" v-if="state == 2" type="success">{{ getName(2) }}</el-tag>
		<el-tag size="mini" v-if="state == 3" type="danger">{{ getName(3) }}</el-tag>
		<el-tag size="mini" v-if="state == 4" type="info">{{ getName(4) }}</el-tag>
	</span>
</template>

<script>
import { getName } from "./states.js";
export default {
	name: "l-approval-state",
	props: {
		state: {
			type: [Number, String],
		},
	},

	methods: {
		getName(state) {
			return getName(state);
		},
	},
};
</script>
